var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIcConversation = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 65,
  height: 64,
  fill: "none",
  viewBox: "0 0 65 64",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M28.744 5.999c-7.67.28-14.41 3.65-18.891 8.728a1.5 1.5 0 1 1-2.25-1.985c5.029-5.698 12.545-9.431 21.031-9.741a1.5 1.5 0 0 1 .11 2.998M41.5 34.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5M30 32a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0M23.5 34.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M57 32C57 19.574 46.926 9.5 34.5 9.5h-5C17.074 9.5 7 19.574 7 32c0 5.781 2.18 11.054 5.764 15.039l-.539 8.084c-.101 1.519 1.463 2.59 2.841 1.946l7.701-3.594A22.5 22.5 0 0 0 29.5 54.5h5C46.926 54.5 57 44.426 57 32M23.664 50.612a3 3 0 0 0-2.166.145l-6.167 2.878.426-6.397a3 3 0 0 0-.762-2.205A19.42 19.42 0 0 1 10 32c0-10.77 8.73-19.5 19.5-19.5h5C45.27 12.5 54 21.23 54 32s-8.73 19.5-19.5 19.5h-5c-2.038 0-3.997-.312-5.836-.888",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcConversation);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };